import { render, staticRenderFns } from "./Lum.vue?vue&type=template&id=025b2b92&scoped=true&"
import script from "./Lum.vue?vue&type=script&lang=js&"
export * from "./Lum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025b2b92",
  null
  
)

export default component.exports